module.exports = __webpack_public_path__ + "img/logo6.23aef74e.png";